module.exports = __webpack_public_path__ + "img/8-Thinking.74a03f1.png";